module.exports = __webpack_public_path__ + "static/img/markend.a2e624c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/markend.png
// module id = 1246
// module chunks = 0